import { IStore } from 'store/types';
import { IIntegration, IIntegrationLocation } from 'types';

export const selectIntegration =
  () =>
  (state: IStore): IIntegration =>
    state.integration;

export const selectIntegrationLocation =
  () =>
  (state: IStore): IIntegrationLocation | undefined =>
    state.integration?.location;
